/* PDP "Make it theirs" stepper (plan 2026-10-05). Presentation only: ss-pdp-letter.js owns
   selection, the ATC gate and the cart. This opens/closes steps, advances on
   ss:pdp-options-changed, counts, and swaps the Next button in for Add to basket until
   nothing blocks the buy. Other code can request a repaint with document event sst:repaint. */
(function () {
  var warned = false;

  // GA4 events (2026-10-12): the same page-scope route as the ss_unlock_* events in sections/unlock-message.liquid
  // (copied from its ssTrack / ssGa4). There is no callable gtag on the page: Shopify's Web Pixels Manager runs
  // GA4 in a sandbox. So each event is queued onto Shopify.analytics.publish (flushed once it boots), pushed to
  // dataLayer when one exists, and sent straight to GA4 G-73V1BV7TXS from this scope with the visitor's own _ga
  // cookies. No personal data: picks and ids only.
  // Unlike the unlock copy, the direct GA4 hit WAITS (QA 2026-10-12: ss_atc_ready fires ~1s in, before
  // Shopify.customerPrivacy loads, so "no API = allowed" sent it for everyone). Hits are held until the privacy
  // API has loaded AND says analytics is allowed AND a real _ga cookie exists (so the hit joins the visitor's own
  // client and session); declined = dropped, and anything still waiting after 20s is dropped, never sent with an
  // invented client id.
  var _ssQueue = [], _ssFlushTimer = 0;
  function ssFlushTrack() {
    if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return false;
    while (_ssQueue.length) {
      var e = _ssQueue.shift();
      try { Shopify.analytics.publish(e[0], e[1]); } catch (err) {}
    }
    return true;
  }
  var GA4_TID = 'G-73V1BV7TXS';
  var _ssGaSeq = 0;
  var _ssGaWait = [], _ssGaSince = 0, _ssGaTimer = 0;
  function ssGaCookie(n) {
    var m = new RegExp('(?:^|; )' + n + '=([^;]*)').exec(document.cookie);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function ssGaCid() { return (/GA1\.\d\.(\d+\.\d+)/.exec(ssGaCookie('_ga')) || [])[1] || ''; }
  // true = send, false = declined (drop), null = privacy API or _ga not there yet (keep waiting)
  function ssGaGate() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!(cp && typeof cp.analyticsProcessingAllowed === 'function')) return null;
    if (!cp.analyticsProcessingAllowed()) return false;
    return ssGaCid() ? true : null;
  }
  function ssGaPump() {
    var ok = ssGaGate();
    if (ok === null && Date.now() - _ssGaSince < 20000) return false;
    var held = _ssGaWait;
    _ssGaWait = [];
    if (ok) held.forEach(function (h) { ssGaSend(h[0], h[1]); });
    return true;
  }
  function ssGa4(name, props) {
    try {
      if (!_ssGaWait.length) _ssGaSince = Date.now();
      _ssGaWait.push([name, Object.assign({}, props)]);
      if (ssGaPump() || _ssGaTimer) return;
      _ssGaTimer = setInterval(function () {
        if (ssGaPump()) { clearInterval(_ssGaTimer); _ssGaTimer = 0; }
      }, 250);
    } catch (e) {}
  }
  function ssGaSend(name, props) {
    try {
      var sid = (/GS\d+\.\d+\.s?(\d+)/.exec(ssGaCookie('_ga_' + GA4_TID.slice(2))) || [])[1] ||
        String(Math.floor(Date.now() / 1000));
      var q = ['v=2', 'tid=' + GA4_TID, '_p=' + Math.floor(Math.random() * 2147483647),
        'cid=' + encodeURIComponent(ssGaCid()), 'sid=' + sid, 'sct=1', 'seg=1',
        '_s=' + (++_ssGaSeq), 'en=' + encodeURIComponent(name),
        'dl=' + encodeURIComponent(location.origin + location.pathname), 'dt=' + encodeURIComponent(document.title),
        'sr=' + screen.width + 'x' + screen.height, 'ul=' + (navigator.language || '').toLowerCase()];
      Object.keys(props || {}).forEach(function (k) {
        var v = props[k];
        if (v === null || v === undefined || v === '') return;
        q.push((typeof v === 'number' ? 'epn.' : 'ep.') + encodeURIComponent(k) + '=' + encodeURIComponent(String(v)));
      });
      fetch('https://analytics.google.com/g/collect?' + q.join('&'),
        { method: 'POST', mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  function ssTrack(name, props) {
    try {
      var p = props || {};
      p.surface = 'pdp';
      _ssQueue.push([name, p]);
      window.__ssTrackLog = (window.__ssTrackLog || []).concat(name).slice(-24);
      if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: name }, p));
      ssGa4(name, p);
      if (!ssFlushTrack() && !_ssFlushTimer) {
        _ssFlushTimer = setInterval(function () {
          if (ssFlushTrack() || !_ssQueue.length) { clearInterval(_ssFlushTimer); _ssFlushTimer = 0; }
        }, 400);
        setTimeout(function () { if (_ssFlushTimer) { clearInterval(_ssFlushTimer); _ssFlushTimer = 0; } }, 20000);
      }
    } catch (e) {}
  }
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function headerOffset() {
    // theme.liquid / header.js write this custom property on <body>
    var h = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height'));
    return (h > 0 ? h : 96) + 16;
  }

  function setup(wrap, steps) {
    var root = wrap.closest('.ss-pdp') || document;
    var count = wrap.querySelector('[data-sst-count]');
    var segs = [].slice.call(wrap.querySelectorAll('[data-sst-seg]'));
    // page-wide: the phone sticky bar is its own .ss-pdp root and carries a Next + progress line too
    var nexts = [].slice.call(document.querySelectorAll('.ss-pdp [data-sst-next]'));
    var ctaSubs = [].slice.call(document.querySelectorAll('.ss-pdp [data-sst-cta-sub]'));
    // first-screen CTA under the price (2026-10-16): its Next/ATC pair is painted with the others below
    var topSet = root.querySelector('[data-sst-top-set]');
    var topCustom = root.querySelector('[data-sst-top-custom]');
    var topCount = root.querySelector('[data-sst-top-count]');
    if (topCount) topCount.textContent = '\u00b7 ' + steps.length + (steps.length === 1 ? ' choice' : ' choices');
    var lastWasKey = false;
    var interacted = false;
    var advTimer = 0;
    var pendingStep = null;
    // Piccolo card (Task 7): the switch shows the bottles; letter.js initWineAddon() owns the choice
    var wine = root.querySelector('.sst-wine[data-wine-addon]');
    var wSwitch = wine && wine.querySelector('[data-sst-wine-toggle]');
    var wBody = wine && wine.querySelector('[data-sst-wine-body]');
    var wNone = wine && wine.querySelector('[data-wine-addon-sw][data-vid=""]');
    var wOpts = wine && wine.querySelector('.c1-wine-options');
    var wSub = wine && wine.querySelector('[data-sst-wine-sub]');
    var wSubOff = wSub ? wSub.textContent : '';
    var wLegal = wine && wine.querySelector('[data-sst-wine-legal]');

    steps.forEach(function (s) {
      var n = s.querySelector('[data-sst-num]');
      // the server renders a tick on a pre-chosen step, so the number comes from data-sst-n
      s._sstNum = n ? (n.getAttribute('data-sst-n') || n.textContent) : '';
      // server markup already matches the load state: record it so the first paint does not rebuild it
      var sub = s.querySelector('[data-sst-sub]');
      if (sub) {
        var val = sub.querySelector('.sst-val');
        sub._sstKey = val ? 'v:' + val.textContent : (s.classList.contains('is-open') ? 'o' : 'c');
      }
    });

    function chosenEl(step) {
      return step.querySelector('.c1-opt-pill.is-sel, [data-print-val][aria-checked="true"]');
    }
    function chosenName(el) {
      var n = el.querySelector('.c1-sw-name');
      return (n && n.textContent.trim()) || el.getAttribute('data-opt-val') || el.getAttribute('data-print-val') || el.getAttribute('data-sw-name') || el.textContent.trim();
    }
    function chosenThumb(el) {
      var img = el.querySelector('img');
      return el.getAttribute('data-ssp-thumb-src') || (img && (img.currentSrc || img.getAttribute('src'))) || '';
    }
    function isOpen(step) { return step.querySelector('[data-sst-toggle]').getAttribute('aria-expanded') === 'true'; }
    function firstUnchosen() {
      for (var i = 0; i < steps.length; i++) if (!chosenEl(steps[i])) return steps[i];
      return null;
    }
    function unchosenAfter(step) {
      for (var i = steps.indexOf(step) + 1; i < steps.length; i++) if (!chosenEl(steps[i])) return steps[i];
      return firstUnchosen();
    }
    function wineOn() { return !!wSwitch && wSwitch.getAttribute('aria-checked') === 'true'; }
    function wineChosen() { return wine ? wine.querySelector('[data-wine-addon-sw][aria-checked="true"]:not([data-vid=""])') : null; }
    // What the Next button should send the shopper to, or null when nothing blocks the buy.
    // Steps first; then a switched-on piccolo with no bottle picked.
    function nextBlocker() {
      var s = firstUnchosen();
      if (s) return { label: 'Next: ' + s.getAttribute('data-sst-short'), target: s, step: s };
      if (wineOn() && !wineChosen()) return { label: 'Choose a bottle', target: wine || wOpts, focusIn: wOpts };
      return null;
    }
    function doneFlags() { return steps.map(function (s) { return !!chosenEl(s); }); }
    function tally(flags) { return flags.filter(Boolean).length; }
    var prevDone = doneFlags();
    // The pre-selected set (letter.js flags it data-sst-default) stays "Our favourite set" until the shopper
    // changes any pick; load churn and deep links never count as a change, and never send ss_pick_changed
    function chosenEls() { return steps.map(chosenEl); }
    var prevEls = chosenEls();
    var handle = root.getAttribute && root.getAttribute('data-handle') || '';
    var userChanged = false;
    var atcReadySent = false;
    function pickChanged(step, el, prev) {
      userChanged = true;
      ssTrack('ss_pick_changed', {
        product_handle: handle,
        step: step.getAttribute('data-sst-kind') || '',
        value: chosenName(el),
        from_default: !!(prev && prev.hasAttribute('data-sst-default-pick'))
      });
      // a step that has been changed no longer holds its default, even if the shopper picks it again
      if (prev) prev.removeAttribute('data-sst-default-pick');
    }

    function scrollToEl(el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: top, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function setOpen(step, open, focus) {
      var t = step.querySelector('[data-sst-toggle]'), body = step.querySelector('[data-sst-body]');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (body) body.hidden = !open;
      step.classList.toggle('is-open', open);
      if (open && body) body.dispatchEvent(new CustomEvent('sst:open'));
      if (open && focus) t.focus({ preventScroll: true });
    }
    function openOnly(step, scroll, focus) {
      steps.forEach(function (s) { if (s !== step) setOpen(s, false); });
      if (step) setOpen(step, true, focus);
      paint(); // before measuring: the done step's thumb changes the layout above the target
      if (step && scroll) scrollToEl(step);
    }
    function cancelAdvance() { clearTimeout(advTimer); pendingStep = null; }

    function paintSub(step, el, open) {
      var sub = step.querySelector('[data-sst-sub]');
      if (!sub) return;
      var kind = sub.getAttribute('data-kind') || '';
      var key = el ? 'v:' + chosenName(el) : (open ? 'o' : 'c');
      if (sub._sstKey === key) return;
      sub._sstKey = key;
      sub.textContent = '';
      // spaces stay outside the aria-hidden dot so screen readers hear "Bath soak 2 options", not one run-on word
      sub.appendChild(document.createTextNode(kind + ' '));
      var sep = document.createElement('span');
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '·';
      sub.appendChild(sep);
      sub.appendChild(document.createTextNode(' '));
      if (el) {
        var v = document.createElement('span');
        v.className = 'sst-val';
        v.textContent = chosenName(el);
        sub.appendChild(v);
      } else {
        sub.appendChild(document.createTextNode(open ? (sub.getAttribute('data-count') || '') + ' options' : 'choose one'));
      }
    }
    function paintThumb(step, el, open) {
      var th = step.querySelector('[data-sst-thumb]');
      if (!th) return;
      var src = el && !open ? chosenThumb(el) : '';
      if (!src) { th.hidden = true; return; }
      var img = th.querySelector('img');
      if (!img) {
        img = document.createElement('img');
        img.alt = '';
        img.width = 88;
        img.height = 88;
        th.appendChild(img);
      }
      if (img.getAttribute('src') !== src) img.src = src;
      th.hidden = false;
    }

    // Progress lines: "N of M chosen", or once every step is chosen one of "Our favourite set" (the default set,
    // untouched), "Your set" (after a real shopper change) or "Ready to send" (an untouched deep link), with
    // "tap a choice to change it" (its own line via CSS, so the inline dot is hidden there). Was "tap any item to
    // swap" until 2026-10-19: untrue, some gifts in every box are fixed.
    function paintLabel(el, set, text) {
      var key = set || text;
      if (el._sstKey === key) return;
      el._sstKey = key;
      el.textContent = set || text;
      if (!set) return;
      var dot = document.createElement('span');
      dot.className = 'sst-tip-dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = ' · ';
      var tip = document.createElement('span');
      tip.className = 'sst-tip';
      tip.textContent = 'tap a choice to change it';
      el.appendChild(dot);
      el.appendChild(tip);
    }

    function paintWine() {
      if (!wine) return;
      var on = wineOn(), el = wineChosen();
      var txt = wSubOff;
      if (on && el) {
        var n = el.querySelector('.c1-wine-name'), pr = el.querySelector('.c1-wine-price');
        txt = (n ? n.textContent.trim() : '') + (pr ? ' · ' + pr.textContent.trim() : '');
      } else if (on) txt = 'Choose a bottle';
      if (wSub.textContent !== txt) wSub.textContent = txt;
      wine.classList.toggle('is-on', on);
      wine.classList.toggle('is-need', on && !el);
    }
    function setLegal(open) {
      if (!wLegal) return;
      var p = document.getElementById(wLegal.getAttribute('aria-controls'));
      wLegal.setAttribute('aria-expanded', open ? 'true' : 'false');
      wLegal.textContent = open ? 'Hide allergy info' : 'Allergy info';
      if (p) p.hidden = !open;
    }
    function setWine(on) {
      wSwitch.setAttribute('aria-checked', on ? 'true' : 'false');
      wBody.hidden = !on;
    }

    function paint() {
      paintWine();
      var done = 0;
      steps.forEach(function (s) {
        var el = chosenEl(s), open = isOpen(s);
        if (el) done++;
        s.classList.toggle('is-done', !!el);
        var num = s.querySelector('[data-sst-num]');
        var want = el ? '✓' : s._sstNum;
        if (num && num.textContent !== want) num.textContent = want;
        paintSub(s, el, open);
        paintThumb(s, el, open);
      });
      var total = steps.length;
      var label = done + ' of ' + total + ' chosen';
      var set = done !== total ? '' : wrap.hasAttribute('data-sst-default') ? 'Our favourite set' : (userChanged ? 'Your set' : 'Ready to send');
      if (count) {
        paintLabel(count, set, label);
        count.classList.toggle('is-all', done === total);
      }
      segs.forEach(function (g, i) { g.classList.toggle('is-on', i < done); });
      if (segs.length !== total && !warned) {
        warned = true;
        console.warn('[sst] segments/steps mismatch', segs.length, total);
      }
      var nb = nextBlocker();
      nexts.forEach(function (b) {
        b.hidden = !nb;
        if (nb && b.textContent !== nb.label) b.textContent = nb.label;
        var cta = b.closest('.sst-cta, .sst-cta-sb, .sst-cta-top');
        var add = cta && cta.querySelector('[data-ss-add]');
        if (add) add.hidden = !!nb;
      });
      // ss_atc_ready: once per page view, the first time the buy-box Add to basket is shown and enabled
      // (the sticky bar mirrors it, so it is never counted twice)
      var buy = !atcReadySent && root.querySelector('.sst-cta [data-ss-add]');
      if (buy && !buy.hidden && !buy.disabled) {
        atcReadySent = true;
        ssTrack('ss_atc_ready', {
          product_handle: handle,
          // data-sst-default = the default set drove the options (no usable ?variant= / ss_opts); a deep link stays
          // deep_link even when letter.js then fills the print
          source: interacted ? 'user' : (wrap.hasAttribute('data-sst-default') ? 'default' : 'deep_link')
        });
      }
      var sub = label, subSet = '';
      if (done === total) {
        if (wineChosen()) sub = 'Incl. piccolo · ready';
        else if (wineOn()) sub = 'Choose a bottle';
        else subSet = set;
      }
      ctaSubs.forEach(function (c) { paintLabel(c, subSet, sub); });
      if (topSet) {
        var topTxt = done !== total ? sub + '.' : wineChosen() ? (set || 'Your set') + ' with a piccolo, ready to send.' :
          wineOn() ? 'Choose a bottle, or switch the piccolo off.' : set === 'Ready to send' ? 'Ready to send.' : set + ', ready to send.';
        if (topSet.textContent !== topTxt) topSet.textContent = topTxt;
      }
      document.dispatchEvent(new CustomEvent('sst:progress', { detail: { done: done, total: total, next: nb && nb.label } }));
    }

    // Before any user input, option changes are deep-link preselects (letter.js) or load
    // churn: open the first unchosen step quietly, never scroll.
    function reconcile() {
      var nxt = firstUnchosen();
      var open = steps.filter(isOpen)[0] || null;
      if (open !== nxt) openOnly(nxt, false, false);
      else paint();
    }

    function scheduleAdvance(step) {
      clearTimeout(advTimer);
      pendingStep = step;
      advTimer = setTimeout(function () {
        pendingStep = null;
        if (!isOpen(step)) return;
        var had = step.contains(document.activeElement) || document.activeElement === document.body;
        var nxt = unchosenAfter(step);
        if (nxt) { openOnly(nxt, true, lastWasKey || had); return; }
        setOpen(step, false);
        paint();
        var cta = root.querySelector('.sst-cta [data-ss-add]');
        if (had) (cta && !cta.hidden && !cta.disabled ? cta : step.querySelector('[data-sst-toggle]')).focus({ preventScroll: true });
      }, 320);
    }

    function onChanged() {
      var now = doneFlags();
      var before = tally(prevDone), after = tally(now);
      var newly = steps.filter(function (s, i) { return now[i] && !prevDone[i]; });
      prevDone = now;
      var els = chosenEls();
      if (interacted) steps.forEach(function (s, i) {
        if (els[i] === prevEls[i]) return;
        wrap.removeAttribute('data-sst-default');
        if (els[i]) pickChanged(s, els[i], prevEls[i]);
      });
      prevEls = els;
      if (!interacted) { reconcile(); return; }
      paint();
      var step = (after > before && newly.filter(isOpen)[0]) ||
        (pendingStep && isOpen(pendingStep) && chosenEl(pendingStep) ? pendingStep : null);
      if (step) scheduleAdvance(step);
    }

    // First paint before any listener exists: if it throws, init's catch reveals everything and nothing can re-hide it.
    reconcile();

    document.addEventListener('keydown', function () { lastWasKey = true; interacted = true; }, true);
    document.addEventListener('pointerdown', function () { lastWasKey = false; interacted = true; }, true);
    // untrusted clicks are scripted (letter.js clicks the default print card on load), not the shopper
    document.addEventListener('click', function (e) { if (e.isTrusted) interacted = true; }, true);

    steps.forEach(function (s) {
      s.querySelector('[data-sst-toggle]').addEventListener('click', function () {
        cancelAdvance();
        if (isOpen(s)) { setOpen(s, false); paint(); } else openOnly(s, false, false);
      });
    });
    // Send the shopper to whatever blocks the buy: open the step, or scroll to the bottles
    function route(nb) {
      cancelAdvance();
      if (nb.step) { openOnly(nb.step, true, true); return; }
      scrollToEl(nb.target);
      var first = (nb.focusIn || nb.target).querySelector('button:not([disabled])');
      if (first && lastWasKey) first.focus({ preventScroll: true });
    }
    nexts.forEach(function (b) {
      b.addEventListener('click', function () {
        var nb = nextBlocker();
        if (nb) route(nb);
      });
    });
    if (topCustom) topCustom.addEventListener('click', function () {
      cancelAdvance();
      openOnly(firstUnchosen() || steps[0], true, lastWasKey);
      ssTrack('ss_customise_click', { product_handle: handle });
    });
    // Belt and braces: paint() hides the sticky ATC while a blocker exists, but a programmatic or AT-driven click
    // on it must still never buy past a missing pick. Capture phase runs before letter.js's handler.
    document.addEventListener('click', function (e) {
      var add = e.target.closest && e.target.closest('[data-sticky-bar] [data-ss-add], [data-sst-top] [data-ss-add]');
      if (!add) return;
      var nb = nextBlocker();
      if (!nb) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      route(nb);
    }, true);
    // ss_atc_click: only when the add really goes ahead. letter.js signals ss:pdp-add-start as it sends /cart/add.js,
    // after the age tick, the one-gift-per-basket check and the double-submit guard, from whichever root was tapped
    document.addEventListener('ss:pdp-add-start', function (e) {
      ssTrack('ss_atc_click', {
        product_handle: handle,
        variant_id: String(e.detail && e.detail.variantId || ''),
        cta: String(e.detail && e.detail.cta || 'main'),
        set_state: wrap.hasAttribute('data-sst-default') ? 'untouched' : (userChanged ? 'customised' : 'deep_link')
      });
    });
    if (wSwitch && wBody) {
      wSwitch.addEventListener('click', function () {
        var on = !wineOn();
        // off = back to "No thanks" through initWineAddon's own handler (labels, price, age box reset);
        // the chips are disabled while an add is in flight, so the switch stays on then
        if (!on && wNone && wNone.disabled) return;
        setWine(on);
        if (!on && wNone && wNone.getAttribute('aria-checked') !== 'true') wNone.click();
        paint();
      });
      // bubble phase on the card: runs after initWineAddon's handler on the tile has updated aria-checked
      wine.addEventListener('click', function (e) {
        var chip = e.target.closest && e.target.closest('[data-wine-addon-sw]');
        if (!chip) return;
        // keep the switch truthful whichever way the radio changed: a bottle = on, "No thanks" = off
        var vid = chip.getAttribute('data-vid');
        if (vid ? !wineOn() : wineOn()) setWine(!!vid);
        paint();
      });
    }
    if (wLegal) wLegal.addEventListener('click', function () { setLegal(wLegal.getAttribute('aria-expanded') !== 'true'); });
    wrap.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || document.documentElement.classList.contains('c1-swv-open')) return;
      var step = e.target.closest && e.target.closest('[data-sst-step]');
      if (!step || !isOpen(step)) return;
      cancelAdvance();
      setOpen(step, false);
      paint();
      step.querySelector('[data-sst-toggle]').focus({ preventScroll: true });
    });
    var jAll = [].slice.call(wrap.querySelectorAll('[data-sst-kind="journal"] a.c1-opt-pill'));
    var jLinks = jAll.filter(function (a) { return !a.classList.contains('is-sel'); });
    // Journal colours are sibling products: keep their links carrying the other picks (ss_opts, read by letter.js).
    // "|" separates one value per option position; siblings must keep identical option values and order.
    jAll.forEach(function (a) {
      if (a.classList.contains('is-sel')) a.addEventListener('click', function (e) { e.preventDefault(); });
      // a journal colour is a page change, so it never reaches onChanged: count it on the tap (the hit is keepalive)
      else a.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var step = a.closest('[data-sst-step]');
        pickChanged(step, a, step && chosenEl(step));
      });
    });
    function carry() {
      if (!jLinks.length) return;
      var groups = [].slice.call(wrap.querySelectorAll('[data-opt-group]'));
      var vals = groups.map(function (g) { var p = g.querySelector('.c1-opt-pill.is-sel'); return p ? p.getAttribute('data-opt-val') : ''; });
      jLinks.forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.href);
        if (vals.join('')) u.searchParams.set('ss_opts', vals.join('|')); else u.searchParams.delete('ss_opts');
        a.setAttribute('href', u.pathname + u.search);
      });
    }
    document.addEventListener('ss:pdp-options-changed', carry);
    carry();

    // "What's inside" follows the picks: each selected pill that resolved to a component (data-inside-handle)
    // renames the value in that tile's caption and its .ph overlay label, and swaps the tile photo to the
    // variant shot when the pill has one (data-inside-img). Driven by ss:pdp-options-changed so the zoom
    // viewer's direct selectPill is covered. The print tile has its own sync (ss-print-carousel.js) and no pill
    // carries its handle. Originals are kept per tile and every pass starts from them, so re-picking never
    // compounds; nothing selected = server markup untouched. Two guards keep the editorial tile honest:
    // a caption that already lists several values of the group is left alone (photo still swaps), and picking
    // the value the original caption names keeps the original styled photo.
    function esc(t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
    function valueRx(vals) {
      var alt = vals.slice().sort(function (a, b) { return b.length - a.length; }).map(esc).join('|');
      return alt ? new RegExp('(^|[^A-Za-z])(' + alt + ')(?![A-Za-z])', 'g') : null;
    }
    function renameValue(text, rx, to) {
      return rx ? text.replace(rx, function (m, pre) { return pre + to; }) : text;
    }
    function namedValues(texts, rx) {
      var seen = {};
      if (rx) texts.forEach(function (t) { t.replace(rx, function (m, pre, v) { seen[v] = 1; return m; }); });
      return Object.keys(seen);
    }
    function syncInside() {
      var picks = {};
      [].forEach.call(wrap.querySelectorAll('[data-opt-group] .c1-opt-pill[data-opt-pos].is-sel[data-inside-handle]'), function (p) {
        picks[p.getAttribute('data-inside-handle')] = p;
      });
      [].forEach.call(document.querySelectorAll('.c1-pol[data-inside-key]'), function (tile) {
        var pick = picks[tile.getAttribute('data-inside-key')];
        var img = tile.querySelector('img'), cap = tile.querySelector('.c1-pol-name'), ph = tile.querySelector('.ph[data-label]');
        if (!pick && !tile._sstIn) return;
        if (!tile._sstIn) {
          tile._sstIn = { src: img ? img.getAttribute('src') : '', label: ph ? ph.getAttribute('data-label') : null, nodes: [] };
          if (cap) [].forEach.call(cap.childNodes, function (n) {
            if (n.nodeType === 3) tile._sstIn.nodes.push({ n: n, text: n.nodeValue });
          });
        }
        var o = tile._sstIn;
        var val = pick && pick.getAttribute('data-opt-val');
        var rx = pick && valueRx([].map.call(pick.closest('[data-opt-group]').querySelectorAll('.c1-opt-pill[data-opt-val]'), function (p) { return p.getAttribute('data-opt-val'); }));
        var named = pick ? namedValues(o.nodes.map(function (r) { return r.text; }), rx) : [];
        var rename = !!pick && named.length < 2;
        var swap = !!pick && !!pick.getAttribute('data-inside-img') && !(named.length === 1 && named[0] === val);
        var src = swap ? pick.getAttribute('data-inside-img') : o.src;
        if (img && img.getAttribute('src') !== src) img.setAttribute('src', src);
        if (img) img.classList.toggle('is-swapped', swap);
        o.nodes.forEach(function (r) {
          var t = rename ? renameValue(r.text, rx, val) : r.text;
          if (r.n.nodeValue !== t) r.n.nodeValue = t;
        });
        if (ph && o.label !== null) {
          var l = rename ? renameValue(o.label, rx, val) : o.label;
          if (ph.getAttribute('data-label') !== l) ph.setAttribute('data-label', l);
        }
      });
    }
    document.addEventListener('ss:pdp-options-changed', syncInside);
    syncInside();

    document.addEventListener('ss:pdp-options-changed', onChanged);
    document.addEventListener('sst:repaint', paint);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { prevDone = doneFlags(); prevEls = chosenEls(); paint(); } });
  }

  function init(wrap) {
    var steps = [].slice.call(wrap.querySelectorAll('[data-sst-step]'));
    if (!steps.length || wrap.getAttribute('data-sst-ready')) return;
    try {
      setup(wrap, steps);
      wrap.setAttribute('data-sst-ready', '1');
    } catch (e) {
      var root = wrap.closest('.ss-pdp') || document;
      [].forEach.call(root.querySelectorAll('[data-sst-body]'), function (b) { b.hidden = false; });
      [].forEach.call(root.querySelectorAll('[data-sst-toggle]'), function (t) { t.setAttribute('aria-expanded', 'true'); });
      [].forEach.call(document.querySelectorAll('.ss-pdp [data-ss-add]'), function (b) { b.hidden = false; });
      [].forEach.call(document.querySelectorAll('.ss-pdp [data-sst-next]'), function (b) { b.hidden = true; });
      // piccolo card: no switch logic, so show the bottles and the legal copy outright
      [].forEach.call(root.querySelectorAll('[data-sst-wine-body], .sst-wine-legal, .sst-wine [data-wine-addon-sw][data-vid=""]'), function (b) { b.hidden = false; });
      [].forEach.call(root.querySelectorAll('[data-sst-wine-toggle], [data-sst-wine-legal]'), function (b) { b.hidden = true; });
      console.error('[sst] stepper failed, showing all options', e);
    }
  }

  // Phones: the box blurb clamps to 2 lines (CSS) behind a Read more toggle. The toggle ships hidden (short
  // blurbs never shift the layout) and is shown only when the text overflows.
  function initMore(btn) {
    var d = document.getElementById(btn.getAttribute('aria-controls'));
    if (!d) return;
    function measure() {
      if (d.classList.contains('is-open')) return; // open: the toggle stays to collapse it again
      btn.hidden = !(d.clientHeight && d.scrollHeight > d.clientHeight + 1);
    }
    btn.addEventListener('click', function () {
      var open = !d.classList.contains('is-open');
      d.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    measure();
  }

  // One-row option rails (4+ values). Arrows for mouse users (CSS shows them from 750px), and the chosen
  // card scrolled into view whenever the step opens (a hidden rail loses its scroll position).
  function initRail(nav) {
    var rail = nav.previousElementSibling;
    if (!rail) return;
    var prev = nav.querySelector('[data-sst-rail-prev]'), next = nav.querySelector('[data-sst-rail-next]');
    var wasShown = false;
    // scroll only flips the arrows; geometry (overflow, photo centre) is measured on open and resize
    function ends() {
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
      return max;
    }
    function paint() {
      nav.classList.toggle('no-overflow', ends() <= 2);
      var img = rail.querySelector('.c1-sw-img');
      if (!img || !img.offsetHeight) return;
      var g = nav.parentNode.getBoundingClientRect(), r = img.getBoundingClientRect();
      nav.style.setProperty('--sst-rail-mid', (r.top - g.top + r.height / 2) + 'px');
    }
    function reveal() {
      var sel = rail.querySelector('.c1-opt-pill.is-sel');
      var wrap = sel && sel.closest('.c1-sw-wrap');
      if (!wrap) return;
      var left = wrap.offsetLeft - rail.offsetLeft - parseFloat(getComputedStyle(rail).paddingLeft || 0);
      if (left < rail.scrollLeft || left + wrap.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollLeft = Math.max(0, left);
    }
    function step(dir) {
      rail.scrollBy({ left: dir * rail.clientWidth * 0.75, behavior: reduced() ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    var body = rail.closest('[data-sst-body]');
    if (body) body.addEventListener('sst:open', function () { reveal(); paint(); });
    rail.addEventListener('scroll', ends, { passive: true });
    window.addEventListener('resize', paint);
    if (window.ResizeObserver) new ResizeObserver(function () {
      var shown = rail.clientWidth > 0;
      if (shown && !wasShown) reveal();
      wasShown = shown;
      paint();
    }).observe(rail);
    paint();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('.ss-pdp [data-sst-rail-nav]'), function (n) {
      try { initRail(n); } catch (e) { console.error('[sst] rail', e); } // never takes the stepper down
    });
    [].forEach.call(document.querySelectorAll('.ss-pdp [data-sst-more]'), initMore);
    [].forEach.call(document.querySelectorAll('.ss-pdp [data-ss-opts]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
